import { Link } from 'react-router-dom';
import { useStoreInfo } from '@/hooks/useStoreInfo';

const NAV_LINKS = [
  { label: 'Inicio',    to: '/' },
  { label: 'Productos', to: '/products' },
  { label: 'Servicios', to: '/#servicios' },
  { label: 'Nosotros',  to: '/about' },
  { label: 'Contacto',  to: '/contact' },
];

export default function Footer() {
  const year = new Date().getFullYear();
  const { info } = useStoreInfo();

  return (
    <footer className="text-white" role="contentinfo" style={{ background: '#1e2d4a' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 md:gap-8">

          {/* Brand */}
          <div className="sm:col-span-2 md:col-span-1">
            <Link to="/" aria-label="ONFASE — Ir al inicio" className="inline-block mb-4 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white rounded-sm">
              <img
                /* Usa tu logo local cuando lo subas a src/assets/ */
                src="https://static.readdy.ai/image/004db39e2894261856b71d2ca60aa0da/e2acf3d8b228a6b4449e2feea2d257ae.png"
                alt="ONFASE"
                className="h-7 w-auto object-contain"
                width="100" height="32"
              />
            </Link>
            <p className="text-blue-200/60 text-sm leading-relaxed max-w-xs">
              Tienda especializada en productos eléctricos, energía solar y herramientas. La Habana, Cuba.
            </p>
          </div>

          {/* Nav */}
          <nav aria-label="Navegación del pie de página">
            <p className="text-white/50 font-semibold text-xs uppercase tracking-wider mb-4">Navegación</p>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-blue-200/60 hover:text-white text-sm transition-colors cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white rounded-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Contact */}
          <address className="not-italic">
            <p className="text-white/50 font-semibold text-xs uppercase tracking-wider mb-4">Contacto</p>
            <ul className="space-y-3">
              <li className="flex items-center gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center shrink-0" aria-hidden="true">
                  <i className="ri-phone-line text-[#4bbfdf] text-sm" />
                </div>
                <a
                  href={`tel:+${info.phone}`}
                  aria-label={`Llamar al ${info.phoneDisplay}`}
                  className="text-sm text-blue-200/60 hover:text-white transition-colors cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white rounded-sm"
                >
                  {info.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center shrink-0" aria-hidden="true">
                  <i className="ri-whatsapp-line text-[#4bbfdf] text-sm" />
                </div>
                <a
                  href={`https://wa.me/${info.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`WhatsApp ${info.phoneDisplay}`}
                  className="text-sm text-blue-200/60 hover:text-white transition-colors cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white rounded-sm"
                >
                  WhatsApp
                </a>
              </li>
              {info.email && (
              <li className="flex items-center gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center shrink-0" aria-hidden="true">
                  <i className="ri-mail-line text-[#4bbfdf] text-sm" />
                </div>
                <a
                  href={`mailto:${info.email}`}
                  aria-label={`Enviar correo a ${info.email}`}
                  className="text-sm text-blue-200/60 hover:text-white transition-colors cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white rounded-sm"
                >
                  {info.email}
                </a>
              </li>
              )}
              <li className="flex items-center gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center shrink-0" aria-hidden="true">
                  <i className="ri-map-pin-line text-[#4bbfdf] text-sm" />
                </div>
                <span className="text-sm text-blue-200/60">La Habana, Cuba</span>
              </li>
            </ul>
          </address>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10" style={{ background: '#192540' }}>
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-blue-200/40 text-xs">
            &copy; {year} ONFASE. Todos los derechos reservados.
          </p>
          <a
            href={`https://wa.me/${info.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Contactar por WhatsApp para crear tu página web"
            className="text-blue-200/50 hover:text-[#4bbfdf] text-[11px] transition-colors cursor-pointer whitespace-nowrap"
          >
            ¿Quieres una página web como esta? <span className="underline font-medium">Contáctanos por WhatsApp</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
